// scrollbar
import 'simplebar-react/dist/simplebar.min.css';
// image
import 'react-lazy-load-image-component/src/effects/blur.css';
// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OverlayProvider } from 'overlay-kit';
import type { CSSProperties } from 'react';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import Router from 'src/routes/sections';

import ThemeProvider from 'src/theme';

import { ReactComponent as SuccessIcon } from './assets/icons/toaster/success_icon.svg';
import { ReactComponent as ErrorIcon } from './assets/icons/toaster/error_icon.svg';
import Toaster from './components/toaster/toaster';
import { handleError } from './utils/api-message';

const TOASTER_STYLE = { '--width': '480px' } as CSSProperties;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false },
    mutations: {
      onError: (error) => {
        handleError(error);
        return false;
        // console.log('error', error);
      }
    }
  },

  queryCache: new QueryCache({
    onError: (error) => {
      handleError(error);
      return false;
      // console.log('error', error);
    }
  })
});

export default function App() {
  useScrollToTop();

  return (
    <SettingsProvider
      defaultSettings={{
        themeMode: 'light', // 'light' | 'dark'
        themeDirection: 'ltr', //  'rtl' | 'ltr'
        themeContrast: 'default', // 'default' | 'bold'
        themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
        themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
        themeStretch: true
      }}
    >
      {/* overlay 위에 토스트 띄우기 위해 위치 이동 */}
      <Toaster
        style={TOASTER_STYLE}
        toastOptions={{
          classNames: {
            content: 'app-toast-content',
            title: 'app-toast-message',
            description: 'app-toast-message'
          },
          style: {
            backgroundColor: '#65768B',
            color: '#fff',
            borderRadius: '10px',
            border: '1px solid #65768B',
            gap: '15px'
          }
        }}
        icons={{
          success: <SuccessIcon />,
          error: <ErrorIcon />
        }}
      />
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <OverlayProvider>
            <MotionLazy>
              <ProgressBar />

              <Router />
            </MotionLazy>
          </OverlayProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </SettingsProvider>
  );
}
